import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Grid, Stack, Typography, IconButton } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';
import { YES_NO } from '../../../../../constants';

export const SurgicalHistoryDetailsForm = ({ onAdd, onClose, setSurgicalHistoryDialog }) => {
  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;

  const formSubmit = (formValue) => {
    onAdd(formValue);
    setSurgicalHistoryDialog(false);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        sx={{ borderBottom: 1, borderColor: 'grey.300', paddingBottom: 2 }}
      >
        <Typography variant="h4" fontWeight="bold" sx={{ marginBottom: '2%', fontSize: '1.5rem', color: '#333' }}>
          Surgical History
        </Typography>
        <IconButton onClick={onClose} sx={{ color: 'red' }}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </Stack>

      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.17, fontWeight: 600, fontSize: '1.2rem' }}>Surgery</Typography>
              <SelectTag formControlSX={{ flex: 1 }} name="surgery" placeholder="surgery" variant="outlined" menus={YES_NO}/>
            </Stack>
      <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem', marginTop: 0 }}>Laparoscopy</Typography>
      <Grid container spacing={2} sx={{ marginTop: 0}}>
        <Grid item xs={12} sm={6}>
          <Stack spacing={0.5}>
          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Laparoscopy</Typography>
              <SelectTag formControlSX={{ flex: 1 }} name="laparoscopy" placeholder="Laparoscopy" variant="outlined" menus={YES_NO} />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Uterus</Typography>
              <TextField sx={{ flex: 1 }} name="uterus" placeholder="Uterus" variant="outlined" />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Fibroid</Typography>
              <TextField sx={{ flex: 1 }} name="fibroid" placeholder="Fibroid" variant="outlined" />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>RT Ovary</Typography>
              <TextField sx={{ flex: 1 }} name="rt_ovary" variant="outlined" placeholder="Rt Ovary"/>
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>RT Tube</Typography>
              <TextField sx={{ flex: 1 }} name="rt_tube" placeholder="Dysmenorrhea" variant="outlined" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>POD</Typography>
              <TextField sx={{ flex: 1 }} name="pod" placeholder="POD" variant="outlined" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Endometriosis</Typography>
              <TextField sx={{ flex: 1 }} name="endometriosis" placeholder="Endometriosis" variant="outlined" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Adhension</Typography>
              <TextField sx={{ flex: 1 }} name="adhension" placeholder="Adhension" variant="outlined" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Opertaive Procedure</Typography>
              <TextField
                sx={{ flex: 1 }}
                name="operative_procedure"
                placeholder="Operative Procedure"
                variant="outlined"
              />
            </Stack>

            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem', marginTop: 2 }}>Hystroscopy</Typography>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Hystroscopy</Typography>
              <TextField sx={{ flex: 1 }} name="hystroscopy" placeholder="Hystroscopy" variant="outlined" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Uterian Cavity</Typography>
              <TextField sx={{ flex: 1 }} name="uterian_cavity" placeholder="Uterian Cavity" variant="outlined" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Rt Ostia</Typography>
              <TextField sx={{ flex: 1 }} name="rt_ostia" placeholder="Uterian Cavity" variant="outlined" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Lt Ostia</Typography>
              <TextField sx={{ flex: 1 }} name="lt_ostia" placeholder="Lt Ostia" variant="outlined" />
            </Stack>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Stack spacing={0.5}>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.48, fontWeight: 600, fontSize: '1.2rem' }}>Date</Typography>
              <TextField sx={{ flex: 1 }} name="laparoscopy_date" type="date" variant="outlined" />
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>By Doctor</Typography>
              <TextField
                sx={{ flex: 1 }}
                name="laparoscopy_by_doctor"
                placeholder="Laparoscopy By Doctor"
                variant="outlined"
              />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.2rem' }}>Adhension</Typography>
              <TextField sx={{ flex: 1 }} name="adhension" placeholder="Adhension" variant="outlined" />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.2rem' }}>LT Ovary</Typography>
              <TextField sx={{ flex: 1 }} name="lt_ovary" placeholder="LT Ovary" variant="outlined" />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.2rem' }}>LT Tube</Typography>
              <TextField sx={{ flex: 1 }} name="lt_tube" placeholder="LT Tube" variant="outlined" />
            </Stack>

            <Grid item xs={12} >
              <Stack
                spacing={0.5}
                direction="row"
                alignItems="center"
                sx={{ width: '100%', marginTop: '36%' }}
              >
                <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.2rem' }}>Date</Typography>
                <TextField sx={{ flex: 0.6 }} name="hystroscopy_date" type='date'  variant="outlined" />
                <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.2rem' }}>By Doctor</Typography>
                <TextField sx={{ flex: 0.6 }} name="hystroscopy_by_doctor" placeholder="By Doctor"  variant="outlined" />
              </Stack>
              <Stack
                spacing={0.5}
                direction="row"
                alignItems="center"
                sx={{ width: '100%'}}
              >
                <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.2rem' }}>Details</Typography>
                <TextField sx={{ flex: 1}} name="uterian_cavity_details"   variant="outlined" placeholder="Uterian Cavity Details" />
              </Stack>
              <Stack
                spacing={0.5}
                direction="row"
                alignItems="center"
                sx={{ width: '100%'}}
              >
                <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.2rem' }}>Details</Typography>
                <TextField sx={{ flex: 1}} name="rt_ostia_details"   variant="outlined" placeholder="RT Ostia Details" />
              </Stack>
              <Stack
                spacing={0.5}
                direction="row"
                alignItems="center"
                sx={{ width: '100%'}}
              >
                <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.2rem' }}>Details</Typography>
                <TextField sx={{ flex: 1}} name="lt_ostia_details" variant="outlined" placeholder="Lt Ostia Details" />
              </Stack>
            </Grid>
          </Stack>
        </Grid>
      </Grid>

      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" sx={{ marginTop: 0.1 }}>
        <Button variant="contained" type="submit">
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
